import React from 'react';
import styled from 'styled-components';

import ExistingImage from './ExistingImage';
import FileSelector from './FileSelector';
import { Crop } from './ImageCropper';
import NewImage from './NewImage';
import { ASPECT_RATIO } from './constants';

export type ImageValue =
  | {
      type: 'existing-image';
      imageUrl: string;
      downloadUrl?: string;
    }
  | { type: 'image-gallery-image'; imageUrl: string }
  | {
      type: 'new-image';
      file: File;
      crop?: Crop;
    }
  | {
      type: 'no-image';
    };

export type Props = {
  className?: string;
  onChange: (value: ImageValue) => void;
  value: ImageValue;
};

const Root = styled.div``;

const ImageUploadInput = ({ className, onChange, value }: Props) => {
  const handleSelectFile = (file: File) => {
    onChange({
      crop: {
        aspect: ASPECT_RATIO,
        position: { x: 0.5, y: 0.5 },
        zoom: 1,
      },
      file,
      type: 'new-image',
    });
  };

  const renderValue = () => {
    switch (value.type) {
      case 'image-gallery-image': {
        return (
          <ExistingImage
            imageUrl={value.imageUrl}
            onRemove={() => {
              onChange({ type: 'no-image' });
            }}
            onSelectFile={handleSelectFile}
          />
        );
      }
      case 'existing-image': {
        return (
          <ExistingImage
            imageUrl={value.imageUrl}
            downloadUrl={value.downloadUrl}
            onRemove={() => {
              onChange({ type: 'no-image' });
            }}
            onSelectFile={handleSelectFile}
          />
        );
      }
      case 'new-image': {
        return (
          <NewImage
            crop={value.crop}
            file={value.file}
            onCropChange={crop => {
              onChange({ ...value, crop });
            }}
            onImageChange={handleSelectFile}
            onRemove={() => {
              onChange({ type: 'no-image' });
            }}
          />
        );
      }
      case 'no-image': {
        return <FileSelector onSelectFile={handleSelectFile} />;
      }
    }
  };

  return <Root className={className}>{renderValue()}</Root>;
};

export default ImageUploadInput;
